import { useState } from "react";
import { SERVICES, TIME_SLOTS, waLink } from "../data/siteData";
import { WhatsAppIcon } from "./WhatsAppButton";

const slotId = (s) => s.toLowerCase().replace(/[:\s]/g, "-");

export const BookingForm = ({ defaultService }) => {
  const [serviceSlug, setServiceSlug] = useState(defaultService || SERVICES[0].slug);
  const service = SERVICES.find((s) => s.slug === serviceSlug) || SERVICES[0];
  const [duration, setDuration] = useState(service.durations[0]);
  const [slot, setSlot] = useState(TIME_SLOTS[0]);

  const onServiceChange = (slug) => {
    const next = SERVICES.find((s) => s.slug === slug);
    setServiceSlug(slug);
    if (!next.durations.includes(duration)) setDuration(next.durations[0]);
  };

  const message = `Hello Belong Spa, I would like to book a service.\nService: ${service.name}\nDuration: ${duration}\nPreferred time slot: ${slot}\nPlease confirm availability.`;

  return (
    <div
      className="rounded-3xl border border-amber-500/20 bg-[#121215] p-8 sm:p-10"
      data-testid="booking-form"
    >
      <div>
        <label
          htmlFor="booking-service"
          className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80"
        >
          Choose a Service
        </label>
        <select
          id="booking-service"
          data-testid="booking-service-select"
          value={serviceSlug}
          onChange={(e) => onServiceChange(e.target.value)}
          className="mt-3 w-full appearance-none rounded-xl border border-amber-500/25 bg-[#0B0B0C] px-5 py-3.5 font-display text-lg text-amber-100 outline-none transition-colors focus:border-amber-400"
        >
          {SERVICES.map((s) => (
            <option key={s.slug} value={s.slug}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-8">
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80">
          Duration {service.minNote ? `· ${service.minNote}` : ""}
        </p>
        <div className="mt-3 flex flex-wrap gap-3" data-testid="booking-durations">
          {service.durations.map((d) => (
            <button
              key={d}
              type="button"
              data-testid={`booking-duration-${d.replace(" ", "-")}`}
              onClick={() => setDuration(d)}
              className={`rounded-full border px-5 py-2 font-mono-alt text-[11px] uppercase tracking-[0.18em] transition-all duration-300 ${
                duration === d
                  ? "border-amber-300 bg-amber-400 text-[#0B0B0C]"
                  : "border-amber-500/25 text-amber-200 hover:border-amber-400/60"
              }`}
            >
              {d}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8">
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-500/80">
          Preferred Time Slot
        </p>
        <div className="mt-3 grid grid-cols-3 gap-2.5 sm:grid-cols-4" data-testid="booking-slots">
          {TIME_SLOTS.map((t) => (
            <button
              key={t}
              type="button"
              data-testid={`booking-slot-${slotId(t)}`}
              onClick={() => setSlot(t)}
              className={`rounded-xl border px-2 py-2.5 font-mono-alt text-[11px] tracking-[0.1em] transition-all duration-300 ${
                slot === t
                  ? "border-amber-300 bg-amber-400 text-[#0B0B0C]"
                  : "border-white/10 text-stone-300 hover:border-amber-400/50"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <a
        href={waLink(message)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="booking-submit-btn"
        className="mt-10 flex w-full items-center justify-center gap-3 rounded-full bg-[#25D366] py-4 font-mono-alt text-xs uppercase tracking-[0.22em] text-[#052e16] transition-all duration-300 hover:bg-[#1fbd59] hover:shadow-[0_0_30px_rgba(37,211,102,0.4)]"
      >
        <WhatsAppIcon className="h-4 w-4" />
        Send Booking Request on WhatsApp
      </a>
      <p className="mt-4 text-center text-xs font-light text-stone-500">
        Opens WhatsApp with your selection pre-filled — our concierge confirms the slot.
      </p>
    </div>
  );
};
